import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

export class PaginatorI18n {
  constructor(private readonly translate: TranslateService) {}

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    this.translate.stream("paginator.paginatorIntl").subscribe((dict) => {
      const originalGetRangeLabel = paginatorIntl.getRangeLabel;
      paginatorIntl.getRangeLabel = (page: number, size: number, len: number) => {
        return originalGetRangeLabel(page, size, len).replace(
          "of",
          this.translate.instant("paginator.of")
        );
      };
      Object.assign(paginatorIntl, dict);
      paginatorIntl.changes.next();
    });
    return paginatorIntl;
  }
}
